    import React from 'react';
    import PropTypes from "prop-types";
    import CoreComponent from "../../../../../../framework/component/CoreComponent";
    import CoreContainer from "../../../../../../framework/container/CoreContainer";
    import ComponentFactory from "../../../../../../framework/factory/ComponentFactory";
    import ContainerFactory from "../../../../../../framework/factory/ContainerFactory";
    import ShippingAction from "../../../action/order/ShippingAction";

    class CreateShipmentButtonSeparatelyComponent extends CoreComponent {
        static className = 'CreateShipmentButtonSeparatelyComponent';

        constructor(props) {
            super(props);
            console.log("Props recebidas no botão:", props.associatedCustomer);
            this.state = {
                isLoading: false,
                allItemsProcessed: this.checkAllItemsProcessed(props.order, props.associatedCustomer), // Verifica se todos os itens foram processados
                partialItemsProcessed: this.checkPartialItemsProcessed(props.order, props.associatedCustomer) // Verifica se pelo menos um item foi processado
            };
        }

        componentWillReceiveProps(nextProps) {
            const { productQtys, afterLoadProductQtys, order, associatedCustomer } = nextProps;
            const { isLoading } = this.state;

            // Verifica o estado dos itens quando as props são atualizadas
            const allItemsProcessed = this.checkAllItemsProcessed(order, associatedCustomer);
            const partialItemsProcessed = this.checkPartialItemsProcessed(order, associatedCustomer);
            this.setState({ allItemsProcessed, partialItemsProcessed });

            if (productQtys && isLoading) {
                this.setState({ isLoading: false }, () => afterLoadProductQtys(true));
            }
        }

        /**
         * Verifica se todos os itens com o mesmo parent_id têm qty_left = 0
         */
        checkAllItemsProcessed(order, associatedCustomer) {
            if (!order || !order.items) return false;

            // Filtra os itens com o mesmo parent_id
            const itemsWithSameParentId = order.items.filter(item => item.parent_item_id === associatedCustomer);

            // Verifica se todos os itens têm qty_left = 0
            return itemsWithSameParentId.every(item => {
                const qtyLeft = item.qty_ordered - item.qty_shipped - item.qty_refunded - item.qty_canceled;
                return qtyLeft === 0;
            });
        }

        /**
         * Verifica se pelo menos um item tem qty_left = 0, mas não todos
         */
        checkPartialItemsProcessed(order, associatedCustomer) {
            if (!order || !order.items) return false;

            // Filtra os itens com o mesmo parent_id
            const itemsWithSameParentId = order.items.filter(item => item.parent_item_id === associatedCustomer);

            // Conta quantos itens têm qty_left = 0
            const processedItemsCount = itemsWithSameParentId.filter(item => {
                const qtyLeft = item.qty_ordered - item.qty_shipped - item.qty_refunded - item.qty_canceled;
                return qtyLeft === 0;
            }).length;

            // Retorna true se pelo menos um item foi processado, mas não todos
            return processedItemsCount > 0 && processedItemsCount < itemsWithSameParentId.length;
        }

        startLoadProductQtys() {
            const { startLoadProductQtys, order, associatedCustomer } = this.props;
            console.log("Iniciando baixa para o grupo:", associatedCustomer);

            // Filtra os itens com o mesmo parent_id
            const itemsWithSameParentId = order.items.filter(item => item.parent_item_id === associatedCustomer);

            // Calcula o qty_left para cada item
            itemsWithSameParentId.forEach(item => {
                const qtyLeft = item.qty_ordered - item.qty_shipped - item.qty_refunded - item.qty_canceled;
                console.log(`Item ${item.sku}: qty_leftButton = ${qtyLeft}`);
            });

            // Dispara a ação para carregar as quantidades dos produtos
            this.setState({ isLoading: true }, () => {
                startLoadProductQtys(order, associatedCustomer);
            });
        }

        /**
         * template to render
         * @returns {*}
         */
        template() {
            const { isLoading, allItemsProcessed, partialItemsProcessed } = this.state;
            const { t } = this.props;
            let classNames = ["btn btn-default btn-order-take-shipment"];

            // Se todos os itens foram processados, desabilita o botão e aplica a classe bg-blue
            if (allItemsProcessed) {
                classNames.push('disabled');
                classNames.push('bg-blue');
            }
            // Se pelo menos um item foi processado (mas não todos), aplica a classe bg-yellow
            else if (partialItemsProcessed) {
                classNames.push('bg-yellow');
            }

            let buttonText;
            if (allItemsProcessed) {
                buttonText = t('Retirado');
            } else if (partialItemsProcessed) {
                buttonText = t('Entrega Parcial');
            } else {
                buttonText = t('Take Shipment');
            }

            return (
                <li>
                    <button
                        className={classNames.join(' ')}
                        onClick={() => !allItemsProcessed && this.startLoadProductQtys()} // Desabilita o clique se todos os itens foram processados
                        disabled={allItemsProcessed} // Desabilita o botão se todos os itens foram processados
                    >
                        {isLoading ? <div className="loader-product" /> : buttonText}
                    </button>
                </li>
            );
        }
    }

    CreateShipmentButtonSeparatelyComponent.propTypes = {
        order: PropTypes.object.isRequired,
        group: PropTypes.object.isRequired,
        canShip: PropTypes.bool.isRequired,
        afterLoadProductQtys: PropTypes.func.isRequired,
        startLoadProductQtys: PropTypes.func.isRequired,
        associatedCustomer: PropTypes.any,
    };

    class CreateShipmentButtonSeparatelyContainer extends CoreContainer {
        static className = 'CreateShipmentButtonSeparatelyContainer';

        static mapState(state) {
            const { productQtys } = state.extension.orderCreateShipmentReducer;
            return {
                productQtys
            };
        }

        static mapDispatch(dispatch) {
            return {
                startLoadProductQtys: (order, associatedCustomer) => {
                    console.log("🛠 Disparando ação startLoadProductQtys");
                    console.log("📦 Pedido (order):", order);
                    console.log("👤 Cliente associadoButton (associatedCustomer):", associatedCustomer);

                    dispatch(ShippingAction.startLoadProductQtys(order, associatedCustomer));
                }
            };
        }
    }

    export default ContainerFactory.get(CreateShipmentButtonSeparatelyContainer).withRouter(
        ComponentFactory.get(CreateShipmentButtonSeparatelyComponent)
    );


// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/component/order/order-detail/CreateShipmentButtonSeparately.js